import { motion } from 'framer-motion';
import { Card, CardContent } from './ui/card';
import { TrendingUp, Clock, ShieldCheck } from 'lucide-react';

const CARDS = [
  { icon: TrendingUp, title: 'Elevate your income', text: 'Learn the skills modern markets actually reward.' },
  { icon: Clock, title: 'Stay ahead of the curve', text: 'Daily signals, strategies and fresh breakdowns every morning.' },
  { icon: ShieldCheck, title: 'Future-proof yourself', text: 'Master wealth creation built for the AI + digital economy.' },
];

export default function NewEconomy() {
  return (
    <section className="section-pad bg-[hsl(240_6%_7%)] border-t border-b border-border">
      <div className="container-x">
        <div className="max-w-3xl mb-10">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-2">Why This Matters Right Now</div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">DOMINATE THE NEW ECONOMY.</h2>
        </div>
        <div className="grid gap-8 lg:grid-cols-2 items-center">
          <div className="space-y-6 text-[hsl(0_0%_82%)] leading-relaxed">
            <div>
              <h3 className="text-xl font-semibold text-white mb-2">Old industries are collapsing</h3>
              <p>New ones are being built overnight. AI, automation, and crypto have rewritten the rules of wealth creation. The skills that made your parents' generation successful will not save yours. The people who recognise this early are the ones who profit.</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-white mb-2">The cost of living is rising</h3>
              <p>Inflation is destroying your savings. A degree doesn't guarantee anything anymore. Multiple income sources are not optional — they are survival.</p>
            </div>
          </div>
          <div className="grid gap-4">
            {CARDS.map((c, i) => (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
              >
                <Card className="card-surface hover:border-[rgba(245,185,66,0.4)] transition-colors">
                  <CardContent className="p-5 flex gap-4 items-start">
                    <div className="h-11 w-11 rounded-xl flex items-center justify-center bg-[rgba(245,185,66,0.08)] text-[hsl(43_92%_56%)] border border-[rgba(245,185,66,0.28)]">
                      <c.icon className="h-5 w-5" />
                    </div>
                    <div>
                      <div className="font-semibold text-lg text-white">{c.title}</div>
                      <p className="text-sm text-muted-foreground mt-1">{c.text}</p>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
